<template>
  <div class="partner">
    <div class="commonwealBanner"></div>
    <Sos />
    <SosForm />
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
import Sos from "./components/sos";
import SosForm from "./components/sosForm";
export default {
  name: "commonweal",
  components: {
    Sos,
    SosForm,
    HomeFooter
  },
  data() {
    return {
      dialogVisbility: false
    };
  },
  methods: {

  }
};
</script>

<style lang="scss">
.commonwealBanner {
  height: 195px;
  background: url(~@/assets/images/zxcImg/zxcBanner1.png) center center no-repeat;
  background-size: contain;
  background-color: #000;
}
</style>
